import * as React from "react"
import { IconSeeker } from "@ui-seeker/core"


export default function IconDetails({ icon, value, tooltip }) {
    return <IconSeeker
        icon={icon}
        iconWeight="solid"
        sx={{ color: value ? "success.dark" : "error.dark", fontSize: "1.5rem" }}
        tooltip={tooltip}
    />
}